import React from "react";
import heart from './pics/svg/heart.svg';
import light from './pics/svg/light.svg';
import question from './pics/svg/question.svg';
import dots from './pics/svg/dots.svg';
import userIcon from "./pics/svg/user-icon.svg";
import fire from './config/fire';
import "./App.css";
import firebase from 'firebase/app';
import 'firebase/auth';

function Nav() {

    let root=document.documentElement,
    darkMode = true,
    lightClicked = false,
    dropdownClicked = false

    
    fire.auth().onAuthStateChanged(() => {
        hideDropdown();
        dropdownClicked = false
    });

    goDark();
    root.style.setProperty('--dropdown-rotate', 'rotate(90deg)')
    window.addEventListener('resize', () =>{
        document.querySelector('.nav-bar').classList.add('hideNav')
    })
    

    function checkWindow() {
        if (window.innerWidth < 600) {
            return 'hideNav'
        }
    }

    function navClick(e) {
        if (e.target.tagName !== "BUTTON") {
            hideDropdown();
            dropdownClicked = !dropdownClicked;
        }
    }


    function invertLight() {
        if (!lightClicked) {
            firstClick()
        }
        darkMode ? goLight() : goDark()
        darkMode = !darkMode
    }

    function invertDropdown() {
        root.style.getPropertyValue('--dropdown-rotate') === 'rotate(90deg)' ? dropdownClicked = false : dropdownClicked = true
        dropdownClicked ? hideDropdown() : showDropdown()
        dropdownClicked = !dropdownClicked
    }

    function showDropdown() {
        document.querySelector('.nav-bar').classList.remove('hideNav')
        let stagger = 0
        document.querySelectorAll('.nav-bar button:not(.dropdown)').forEach(button => {
            setTimeout(() => {
                button.classList.add('slideIn')
            }, stagger);
            stagger += 100
        })
        document.querySelector('.nav-bar').style.pointerEvents="all"
        root.style.setProperty('--nav-blur', 'blur(5px)')
        root.style.setProperty('--dropdown-rotate', 'rotate(0deg)')
    }
    function hideDropdown() {
        document.querySelector('.nav-bar').classList.add('hideNav')
        document.querySelectorAll('.nav-bar button:not(.dropdown)').forEach(button => {
            button.classList.remove('slideIn')
        })
        document.querySelector('.nav-bar').style.pointerEvents = "none"
        root.style.setProperty('--nav-blur', 'blur(0px)')
        root.style.setProperty('--dropdown-rotate', 'rotate(90deg)')
    }

    function firstClick() {
        root.style.setProperty('--back-transition', '0.3s')
        lightClicked = !lightClicked
    }

    function goLight() {
        var user = firebase.auth().currentUser;
        if (user) {
            document.querySelector(".user img").style.filter = "unset";
        }
        root.style.setProperty('--light-rotate', 'rotate(180deg)')
        root.style.setProperty('--back', '#f3f3f3')
        root.style.setProperty('--main', '#444444')
        root.style.setProperty('--invert', 'invert(1)')
        root.style.setProperty('--uninvert', 'invert(0.2)')
        root.style.setProperty('--nav-opacity', 0.4)
        root.style.setProperty('--border', '#aaaaaa')
        root.style.setProperty('--mid', '#dddddd')
        root.style.setProperty('--show-hover', '#f5f5f5')
        root.style.setProperty('--heading', '#444444')
        root.style.setProperty('--nc-hover', '#eeeeee')
        root.style.setProperty('--nc-back', '#e8e8e8')
        root.style.setProperty('--nc-text', '#2b2b2b')
        root.style.setProperty('--shadow', '#00000055')
        root.style.setProperty('--nav-back', '#ffffffdd')
        root.style.setProperty('--login-back', '#00000033') 
        root.style.setProperty('--fav-back', '#ffffff33') 
    }
    
    function goDark() {
        root.style.setProperty('--light-rotate', '')
        root.style.setProperty('--back', '#000000')
        root.style.setProperty('--main', '#ffffff')
        root.style.setProperty('--invert', 'invert(0)')
        root.style.setProperty('--uninvert', 'invert(1)')
        root.style.setProperty('--nav-opacity', 0.6)
        root.style.setProperty('--border', '#545454')
        root.style.setProperty('--mid', '#808080')
        root.style.setProperty('--show-hover', '#101010')
        root.style.setProperty('--heading', '#c4c4c4')
        root.style.setProperty('--nc-hover', '#000000')
        root.style.setProperty('--nc-back', '#181818')
        root.style.setProperty('--nc-text', '#a7a7a7')
        root.style.setProperty('--shadow', '#ffffff55')
        root.style.setProperty('--nav-back', '#000000dd')
        root.style.setProperty('--login-back', '#ffffff33')
        root.style.setProperty('--fav-back', '#ffffff33')
    }

    function showLoginWrapper() {
        document.querySelector('.login-wrapper').style.transform = "scale(1)"
        document.querySelector('.login-wrapper').style.opacity = 1
        document.querySelector('.login-wrapper').style.pointerEvents = "all"
        document.querySelector('button.Login').style.pointerEvents = "all"
    }
    function showLogoutWrapper() {
        document.querySelector('.logout-wrapper').style.transform = "scale(1)"
        document.querySelector('.logout-wrapper').style.opacity = 1
        document.querySelector('.logout-wrapper').style.pointerEvents = "all"
        document.querySelector('button.Logout').style.pointerEvents = "all"
    }

    function onUserClick() {
        var user = firebase.auth().currentUser;

        if (user) {
            showLogoutWrapper();
        } else {
            showLoginWrapper();
        }

    }

    function showAboutWrapper() {
        document.querySelector('.sticky .close').style.pointerEvents = "all"
        document.querySelector('.about-wrapper').style.transform = "scale(1)"
        document.querySelector('.about-wrapper').style.opacity = 1
        document.querySelector('.about-wrapper').style.pointerEvents = "all"
    }
    function onAboutClick() {
        showAboutWrapper();
    }

    function showFavouritesWrapper() {
        document.querySelector('.fixed .close').style.pointerEvents = "all"
        document.querySelector('.favourites-wrapper').style.transform = "scale(1)"
        document.querySelector('.favourites-wrapper').style.opacity = 1
        document.querySelector('.favourites-wrapper').style.pointerEvents = "all"
    }
    function onFavouritesClick() {
        showFavouritesWrapper();
    }

    return (
        <div onMouseDown={navClick} className={`nav-bar ${checkWindow()}`}>
            <div className="left">
                <button onClick={invertDropdown} className="circle dropdown">
                    <img src={dots} alt="dropdown" />
                </button>
                <button onClick={onAboutClick} className="circle info">
                    <img src={question} alt="info" />
                </button>
                <button onClick={invertLight} className="circle light">
                    <img src={light} alt="light" />
                </button>
            </div>
            <div className="right">
                <button onClick={onFavouritesClick} className="circle favourites">
                    <img src={heart} alt="heart" />
                </button>
                <button onClick={onUserClick} className="circle user">
                    <img src={userIcon} alt="user" />
                </button>
            </div>
        </div>
    );
}

export default Nav;
